module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page--spacious",
    attrs: {
      "data-app": ""
    }
  }, [_c('div', {
    staticClass: "page__container page__container-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('device-pairing', {
    attrs: {
      "sectionWrapperClass": "page__section",
      "pinRefreshable": false
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__header"
  }, [_c('h2', {
    staticClass: "page__title title--general title--2"
  }, [_vm._v("\n\t\t\t\tPair your first device\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-524fb179","hasScoped":false}!./app/components/devices/setup-first-device/template.html
// module id = 384
// module chunks = 0